import {Component, OnInit, ViewChild} from '@angular/core';
import {RdsMenuComponent} from '@rds/angular-components';
import { combineLatest, debounceTime, distinctUntilChanged, Observable } from 'rxjs';
import * as fromUser from '@app/core/user/store';
import {RoleNames} from '@core/enums/roles.enum';
import {select, Store} from '@ngrx/store';
import * as fromTiles from '@app/dashboard/store/tiles';
import {MENU_ITEMS, MenuItem} from '@core/models/menu';
import * as fromFreezeBlock from '@app/root-store/ui/freeze-block/freeze-block.selectors';

@Component({
  selector: 'rh-create-content-button',
  templateUrl: './create-content-button.component.html',
  styles: []
})
export class CreateContentButtonComponent implements OnInit {
  @ViewChild("menu", {static: true}) menu: RdsMenuComponent;

  blocked$: Observable<boolean> = this.store$.pipe(select(fromFreezeBlock.selectBlocked));
  rhRoles$: Observable<Array<RoleNames>> = this.store$.pipe(select(fromUser.selectRoles));
  menuItems: Array<MenuItem> = [];

  filterMenuItem(roles, blocked: boolean) {
    return MENU_ITEMS.filter(tile =>  (tile.roles.length === 0 || tile.roles.some(r => roles.includes(r)))).map(i => ({...i, blocked: blocked && i.hide}));
  }


  ngOnInit(): void {
    combineLatest(this.blocked$, this.rhRoles$).pipe(
      debounceTime(50),
      distinctUntilChanged()
    ).subscribe(([blocked, roles]) => {
      let allRoles = [...roles];
      this.menuItems = this.filterMenuItem(allRoles, blocked);
    });
  }

  constructor(private store$: Store<fromTiles.State>,) {
  }
}
